import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from '@/api/index';
import { CLIENT_URL } from '@/constants/index';

export const miniMarketApi = createApi({
  reducerPath: 'miniMarketApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['MiniMarket'],
  endpoints: (builder) => ({
    getProductList: builder.query({
      query: ({ lang, limit, page, brands, colors, storages }) => ({
        baseURL: CLIENT_URL,
        headers: { 'Accept-Language': lang },
        url: 'products/',
        params: {
          limit,
          page,
          brands,
          colors,
          storages,
        },
        method: 'GET',
      }),
    }),
    getBrands: builder.query({
      query: ({ lang }) => ({
        baseURL: CLIENT_URL,
        headers: { 'Accept-Language': lang },
        url: '/products/brands/',
        method: 'GET',
      }),
    }),
    getStorages: builder.query({
      query: ({ lang }) => ({
        baseURL: CLIENT_URL,
        headers: { 'Accept-Language': lang },
        url: '/products/storages/',
        method: 'GET',
      }),
    }),
    getColors: builder.query({
      query: ({ lang }) => ({
        baseURL: CLIENT_URL,
        headers: { 'Accept-Language': lang },
        url: '/products/colors/',
        method: 'GET',
      }),
    }),
    getBranches: builder.query({
      query: ({ lang }) => ({
        baseURL: CLIENT_URL,
        headers: { 'Accept-Language': lang },
        url: 'products/pickup-points/',
        method: 'GET',
      }),
    }),
    completeOrder: builder.mutation({
      query: ({ lang, data }) => ({
        baseURL: CLIENT_URL,
        data,
        headers: {
          'Accept-Language': lang,
        },
        url: 'products/orders/',
        method: 'POST',
      }),
    }),
  }),
});

export const hooks = {
  useGetBrands: miniMarketApi.useGetBrandsQuery,
  useGetStorages: miniMarketApi.useGetStoragesQuery,
  useGetColors: miniMarketApi.useGetColorsQuery,
  useGetProductList: miniMarketApi.useGetProductListQuery,
  useGetBranches: miniMarketApi.useGetBranchesQuery,
  useCompleteOrder: miniMarketApi.useCompleteOrderMutation,
};

export default miniMarketApi;
